import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS } from 'constants/promotions';
import { isBlank } from 'helpers/verify';
import { selectPagePromotion } from 'redux/modules/page';
import { readSessionStorage } from 'redux/saga/helpers/local-storage';
export var DEFAULT_PAGE_PROMOTION_SESSION_KEY = 'cpDefaultPagePromotion';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    pagePromotionAlias: selectPagePromotion(state)
  };
};
export var PagePromotionCtaUnwrapped =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PagePromotionCtaUnwrapped, _PureComponent);

  function PagePromotionCtaUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PagePromotionCtaUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PagePromotionCtaUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      sessionPromotionAlias: null
    });

    return _this;
  }

  _createClass(PagePromotionCtaUnwrapped, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // This is done to achieve two things:
      // 1. A valid SSR vs CSR diff, without having to skip rendering of button on server.
      // 2. A re-render once it mounts on the client, if the session storage var exists.
      var sessionPromotionAlias = readSessionStorage(DEFAULT_PAGE_PROMOTION_SESSION_KEY, null, true);

      if (!isBlank(sessionPromotionAlias)) {
        this.setState({
          sessionPromotionAlias: sessionPromotionAlias
        });
      }
    }
  }, {
    key: "getPromotionAlias",
    value: function getPromotionAlias() {
      var pagePromotionAlias = this.props.pagePromotionAlias;
      var sessionPromotionAlias = this.state.sessionPromotionAlias;
      return pagePromotionAlias && pagePromotionAlias !== GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS ? pagePromotionAlias : sessionPromotionAlias || GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ctaCopy = _this$props.ctaCopy,
          extraClassForLink = _this$props.extraClassForLink,
          extraClassForWrapper = _this$props.extraClassForWrapper,
          handleClick = _this$props.onClick;
      return React.createElement("div", {
        className: extraClassForWrapper
      }, React.createElement(Link, {
        className: classNames('bt', extraClassForLink),
        onClick: handleClick,
        to: "/pricing/".concat(this.getPromotionAlias())
      }, ctaCopy || React.createElement(FormattedMessage, {
        id: "page-promotion.cta.copy",
        defaultMessage: "Start a free trial"
      })));
    }
  }]);

  return PagePromotionCtaUnwrapped;
}(PureComponent);
PagePromotionCtaUnwrapped.propTypes = {
  ctaCopy: PropTypes.node,
  extraClassForLink: PropTypes.string,
  extraClassForWrapper: PropTypes.string,
  onClick: PropTypes.func,
  pagePromotionAlias: PropTypes.string
};
export var PagePromotionCta = connect(mapStateToProps)(PagePromotionCtaUnwrapped);